import styled from 'styled-components'
import { Modal } from 'react-bootstrap'
import {
  meetingRoomModalHeaderStyles,
  createMeetingRoomModalDialogStyles,
  MEETING_ROOM_MODAL_WIDTH,
} from '../../shared/meetingRoomModalStyles'

export const ACCESS_TIME_ICON_URL = '/icon/access-time.svg'
export const CALENDAR_ICON_URL = '/icon/calendar.svg'

export const StyledModal = styled(Modal)`
  ${createMeetingRoomModalDialogStyles(MEETING_ROOM_MODAL_WIDTH)}

  ${meetingRoomModalHeaderStyles}

  .modal-header {
    .btn-close {
      filter: none;
      opacity: 0.5;
    }
  }

  .modal-title {
    font-weight: 600;
    font-size: 22px;
    line-height: 120%;
  }

  .modal-body {
    padding: 16px 24px 24px;
  }
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
`

export const FieldRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const FieldRowGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`

export const FieldLabel = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 140%;
  color: var(--grey);
`

export const FieldValue = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  color: var(--grey);
`

export const TimeFieldIcon = styled.img`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`

export const CalendarFieldIcon = styled.img`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`

export const TimeFieldValue = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 400;
  color: var(--grey);
  line-height: 140%;
`
